import { lucenceCardioHemeRisk, lucenceInsight } from './initial/flow';

const LucenceCardioHemeRISKFlows = {
  lucenceCardioHemeRisk,
  lucenceInsight
};

export default LucenceCardioHemeRISKFlows;
